import { WaitingDialogComponent } from './../shared/waiting-dialog/waiting-dialog.component';
import { ComboDialogComponent } from './../shared/combo-dialog/combo-dialog.component';
import { Component, OnInit } from '@angular/core';
import { DbmanagerService } from '../services/dbmanager.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { RenameDialogComponent } from '../shared/rename-dialog/rename-dialog.component';
import { DataDialogComponent } from '../shared/data-dialog/data-dialog.component';
import { FieldType } from '../models/Item';
import { ImgDialogComponent } from '../shared/img-dialog/img-dialog.component';

@Component({
  selector: 'app-itemdetails',
  templateUrl: './itemdetails.component.html',
  styleUrls: ['./itemdetails.component.css'],

})

export class ItemdetailsComponent implements OnInit {
  fieldType = FieldType;

  FieldsValues: Array<any>;
  FieldsEditOptions: Array<boolean>;
  FieldsTitles: Array<string>;

  CommercialPhoto = '';
  CommercialPhotoObject: any ;
  PhotoUrl = '';
  photos: Array<string>;
  photosFiles: Array<string>;
  PHOTO_OBJECT: Map<string, any>;
  photoSlot = 0;
  public saveButt = false;
  waitingAnimationRef;
  messageLinkedField = '';

  constructor(private dbService: DbmanagerService, private route: ActivatedRoute, private router: Router, private dialog: MatDialog) {  }

  ngOnInit(): void {
    this.route.queryParams.subscribe( params => {
      this.FieldsEditOptions = new Array<boolean>(13).fill(false);
      this.FieldsTitles = Array<string>(13);
      this.FieldsTitles[FieldType.RFIDNumber] = $localize`:@@itemdetails.rfidNumber:Numer RFID`;
      this.FieldsTitles[FieldType.EvidNumber] = $localize`:@@itemdetails.inventoryNr:Numer Inwentaryzacyjny`;
      this.FieldsTitles[FieldType.Category] = $localize`:@@itemdetails.category:Numer Kategoria`;
      this.FieldsTitles[FieldType.Mark] = $localize`:@@itemdetails.mark:Marka`;
      this.FieldsTitles[FieldType.PurchaseDate] = $localize`:@@itemdetails.purchasedate:Data Zakupu`;
      this.FieldsTitles[FieldType.Size] =  $localize`:@@itemdetails.size:Rozmiar`;
      this.FieldsTitles[FieldType.Link] = $localize`:@@itemdetails.link:Link`;
      this.FieldsTitles[FieldType.State] = $localize`:@@itemdetails.state:Ilość/Stan`;
      this.FieldsTitles[FieldType.Location] = $localize`:@@itemdetails.location:Lokalizacja`;
      this.FieldsTitles[FieldType.Remarks] = $localize`:@@itemdetails.remarks:Uwagi`;
      this.FieldsTitles[FieldType.Description] = $localize`:@@itemdetails.desc:Opis`;
      this.FieldsTitles[FieldType.Title] = $localize`:@@itemdetails.title:Tytuł`;
      this.FieldsTitles[FieldType.LinkedFileds] = $localize`:@@itemdetails.linkedproducts:Produkty powiązane`;

      this.FieldsValues = new Array<any>(13);
      this.FieldsValues[FieldType.RFIDNumber] = this.dbService.tagItems.get(params.UID).TAG_UID;
      this.FieldsValues[FieldType.EvidNumber] = this.dbService.tagItems.get(params.UID).REG_NUM;

      this.FieldsValues[FieldType.Category] = this.dbService.tagItems.get(params.UID).CATEGORY;
      this.FieldsValues[FieldType.Mark] = this.dbService.tagItems.get(params.UID).MARK;
      try {
        const date =  (Object)(this.dbService.tagItems.get(params.UID).PURCHASE_DATE) ;
        this.FieldsValues[FieldType.PurchaseDate] = date.toDate();
      } catch {
        console.log('ERR: PURCHASE_DATE');
        this.FieldsValues[FieldType.PurchaseDate] = '';
      }
      this.FieldsValues[FieldType.Size] = this.dbService.tagItems.get(params.UID).SIZE;
      this.FieldsValues[FieldType.Link] = this.dbService.tagItems.get(params.UID).LINK;
      this.FieldsValues[FieldType.Description] = this.dbService.tagItems.get(params.UID).DESCRIPTION;
      this.FieldsValues[FieldType.Title] = this.dbService.tagItems.get(params.UID).TITLE;

      try {
        this.FieldsValues[FieldType.LinkedFileds] = this.dbService.tagItems.get(params.UID).LINKED_FIELDS.slice();
      } catch {
        this.FieldsValues[FieldType.LinkedFileds] = new Array();
      }

      this.CommercialPhoto = this.dbService.tagItems.get(params.UID).PHOTO;
      if ((this.CommercialPhoto === undefined) || (this.CommercialPhoto.length < 5)) {
        this.CommercialPhoto = '/assets/placeholder.png' ;
      }

      this.FieldsValues[FieldType.Location] = this.dbService.eventItems.get(params.UID).LOCATION;
      this.FieldsValues[FieldType.Remarks] = this.dbService.eventItems.get(params.UID).REMARKS;
      this.FieldsValues[FieldType.State] = this.dbService.eventItems.get(params.UID).STATE;

      this.photos = new Array<string>();
      this.photosFiles = new Array<string>();
      if (this.dbService.eventItems.get(params.UID).PHOTOS !== undefined) {
        this.PHOTO_OBJECT = new Map(Object.entries(this.dbService.eventItems.get(params.UID).PHOTOS));
      } else {
        this.PhotoUrl = '/assets/placeholder.png' ;
      }
      if (this.PHOTO_OBJECT !== undefined) {
          this.PHOTO_OBJECT.forEach( (photo, index) => {
          this.photos[+index] = photo ;
          if ((photo.length > 0) && (this.PhotoUrl.length === 0)) {
            this.PhotoUrl = photo;
          }
        });
      }
    });
  }

  openHistory() {
    this.router.navigate(['/history'], {
      queryParams: {
        UID: this.FieldsValues[FieldType.RFIDNumber]
      }
    });
  }

  saveData() {
    this.waitingAnimationRef = this.dialog.open(WaitingDialogComponent,  { disableClose: true, panelClass: 'waitingclass' }) ;
    this.saveButt = false;
    const tag = this.dbService.tagItems.get(this.FieldsValues[FieldType.RFIDNumber]) ;
    const event = this.dbService.eventItems.get(this.FieldsValues[FieldType.RFIDNumber]) ;
    const newphotos = new Map<number, string>();
    if  ((this.CommercialPhoto !== '/assets/placeholder.png') &&
         (tag.PHOTO !== this.CommercialPhoto) &&
         (this.CommercialPhotoObject !== '')) {
      newphotos.set(-1, this.CommercialPhotoObject);
    }
    this.photos.forEach((photo, index) => {
      if ((this.PHOTO_OBJECT === undefined) || (photo !== new Map(Object.entries(this.dbService.eventItems.get(
        this.FieldsValues[FieldType.RFIDNumber]).PHOTOS)).get(index.toString()))) {
        if (photo.length > 0) {
          newphotos.set(index, this.photosFiles[index]);
        }
      }
    });
    if (newphotos.size > 0) {
      this.dbService.uploadImages(this.FieldsValues[FieldType.RFIDNumber], newphotos) ;
      const subscribver = this.dbService.getUploadedPhotos().subscribe(urls => {
      urls.forEach((photo, index) => {
        if (index === -1) {
          this.CommercialPhoto = photo;
          } else {
            this.photos[index] = photo;
          }
        });
      this.saveChanges(tag, event);
      subscribver.unsubscribe();
      });
    } else {
      this.saveChanges(tag, event);
    }
  }

  private saveChanges(tag, event) {
    let tagData = new Object();
    let eventData = new Object();
    if (tag.CATEGORY !== this.FieldsValues[FieldType.Category]) {
      tagData = Object.assign(tagData, {CATEGORY: this.FieldsValues[FieldType.Category]});
    }
    if (tag.MARK !== this.FieldsValues[FieldType.Mark]) {
      tagData = Object.assign(tagData, {MARK: this.FieldsValues[FieldType.Mark]});
    }
    try {
      if (((Object)(tag.PURCHASE_DATE)).toDate().toString() !== this.FieldsValues[FieldType.PurchaseDate].toString()) {
        tagData = Object.assign(tagData, {PURCHASE_DATE: this.FieldsValues[FieldType.PurchaseDate]});
      }
    } catch {

    }
    if (tag.SIZE !== this.FieldsValues[FieldType.Size]) {
      tagData = Object.assign(tagData, {SIZE: this.FieldsValues[FieldType.Size]});
    }
    if (tag.LINK !== this.FieldsValues[FieldType.Link]) {
      tagData = Object.assign(tagData, {LINK: this.FieldsValues[FieldType.Link]});
    }
    if ((tag.PHOTO !== this.CommercialPhoto) && (this.CommercialPhoto !== '/assets/placeholder.png')) {
      tagData = Object.assign(tagData, {PHOTO: this.CommercialPhoto});
    } else if ((tag.PHOTO !== this.CommercialPhoto) && (this.CommercialPhoto === '/assets/placeholder.png')) {
      tagData = Object.assign(tagData, {PHOTO: ''});
    }

    if (tag.DESCRIPTION !== this.FieldsValues[FieldType.Description]) {
      tagData = Object.assign(tagData, {DESCRIPTION: this.FieldsValues[FieldType.Description]});
    }
    if (tag.TITLE !== this.FieldsValues[FieldType.Title]) {
      tagData = Object.assign(tagData, {TITLE: this.FieldsValues[FieldType.Title]});
    }
    try {
      if ((tag.LINKED_FIELDS === undefined) && (this.FieldsValues[FieldType.LinkedFileds].length > 0) ||
          ((tag.LINKED_FIELDS !== undefined) && (tag.LINKED_FIELDS.length !== this.FieldsValues[FieldType.LinkedFileds].length))
        ) {
        tagData = Object.assign(tagData, {LINKED_FIELDS: this.FieldsValues[FieldType.LinkedFileds]});
      } else if (tag.LINKED_FIELDS !== undefined) {
        let diffDetected = false;
        tag.LINKED_FIELDS.forEach(element => {
          if (!this.FieldsValues[FieldType.LinkedFileds].includes(element)) {
            diffDetected = true;
          }
        });
        this.FieldsValues[FieldType.LinkedFileds].forEach(element => {
          if (!tag.LINKED_FIELDS.includes(element)) {
            diffDetected = true;
          }
        });
        if (diffDetected) {
          tagData = Object.assign(tagData, {LINKED_FIELDS: this.FieldsValues[FieldType.LinkedFileds]});
        }
      }
    } catch {
      console.log('LINKED_FIELDS EMPTY');
    }
    if (Object.keys(tagData).length > 0 ) {
      tagData = Object.assign(tagData, {EDIT_DATETIME: new Date()});
      if (tag.USER_ID !== this.dbService.currentUserID) {
        tagData = Object.assign(tagData, {USER_ID: this.dbService.currentUserID});
      }
    }

    if (event.STATE !== this.FieldsValues[FieldType.State]) {
      eventData = Object.assign(eventData, {STATE: this.FieldsValues[FieldType.State]});
    }
    if (event.LOCATION !== this.FieldsValues[FieldType.Location]) {
      eventData = Object.assign(eventData, {LOCATION: this.FieldsValues[FieldType.Location]});
      const cord =  new Map<string, Map<string, number>>();
      eventData = Object.assign(eventData, {COORD: {}});
    }
    if (event.REMARKS !== this.FieldsValues[FieldType.Remarks]) {
      eventData = Object.assign(eventData, {REMARKS: this.FieldsValues[FieldType.Remarks]});
    }
    let newPhotos = false;
    this.photos.forEach((photo, index) => {
      if ((this.PHOTO_OBJECT === undefined) || (photo !== new Map(Object.entries(this.dbService.eventItems.get(
        this.FieldsValues[FieldType.RFIDNumber]).PHOTOS)).get(index.toString()))) {
          newPhotos = true;
      }
    });
    if (newPhotos !== false) {
      eventData = Object.assign(eventData, {PHOTOS: { 0 : (this.photos[0] !== undefined) ? this.photos[0] : '',
                                                      1 : (this.photos[1] !== undefined) ? this.photos[1] : '',
                                                      2 : (this.photos[2] !== undefined) ? this.photos[2] : '',
      }});
    }
    if ((Object.keys(eventData).length > 0 ) && (event.USER_ID !== this.dbService.currentUserID)) {
      eventData = Object.assign(eventData, {USER_ID: this.dbService.currentUserID});
    }
    if (Object.keys(eventData).length > 0 ) {
      eventData = Object.assign(eventData, {EVENT_DATETIME: new Date()});
      if (tag.USER_ID !== this.dbService.currentUserID) {
        eventData = Object.assign(eventData, {USER_ID: this.dbService.currentUserID});
      }
    }

    this.dbService.updateEventItem(this.FieldsValues[FieldType.RFIDNumber], eventData);
    this.dbService.updateTagItem(this.FieldsValues[FieldType.RFIDNumber], tagData);
    this.waitingAnimationRef.close();
  }

  getType(): string {
    return this.dbService.type;
  }

  saveButtonAvailable(): boolean {
    return this.saveButt ;
  }

  leftPhotoClick() {
    this.photoSlot--;
    if (this.photoSlot === -1 ) {
      this.photoSlot = 2;
    }
    if ((this.photos[this.photoSlot] !== undefined) && (this.photos[this.photoSlot].length > 0)) {
      this.PhotoUrl = this.photos[this.photoSlot] ;
    } else {
      this.PhotoUrl = '/assets/placeholder.png' ;
    }
  }

  rightPhotoClick() {
    this.photoSlot++;
    if (this.photoSlot === 3 ) {
      this.photoSlot = 0;
    }
    if ((this.photos[this.photoSlot] !== undefined) && this.photos[this.photoSlot] !== '') {
      this.PhotoUrl = this.photos[this.photoSlot] ;
    } else {
      this.PhotoUrl = '/assets/placeholder.png' ;
    }
  }

  editMousePresence(field: FieldType, mosueEnter: boolean) {
    this.FieldsEditOptions[field] = mosueEnter ;
  }

  fileUpload(event, mainPhoto: boolean) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent) => {
        if (mainPhoto  === true) {
          this.CommercialPhoto = ((e.target as FileReader).result as string);
          this.CommercialPhotoObject = event.target.files[0] ;
        } else {
          this.PhotoUrl = ((e.target as FileReader).result as string);
          this.photos[this.photoSlot] = ((e.target as FileReader).result as string);
          this.photosFiles[this.photoSlot] = event.target.files[0] ;
        }
        this.saveButt = true;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  fileRemove(mainPhoto: boolean) {
    this.saveButt = true;
    if (mainPhoto === true) {
      this.CommercialPhoto = '/assets/placeholder.png' ;
      this.CommercialPhotoObject = '';
    } else {
      this.PhotoUrl = '/assets/placeholder.png';
      this.photos[this.photoSlot] = '' ;
      this.photosFiles[this.photoSlot] = '' ;
    }
  }

  removeLinkedTag(selectedTags) {
    this.saveButt = true;
    selectedTags.forEach(element => {
      this.FieldsValues[FieldType.LinkedFileds].splice(this.FieldsValues[FieldType.LinkedFileds].indexOf(element.value), 1);
    });
  }

  editDataField(field: FieldType, dialCOntent: string) { // zamienic to na enuma fieldType
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      id: 1,
      content: dialCOntent
    };
    const dataDialogRef = this.dialog.open(DataDialogComponent, dialogConfig).afterClosed().subscribe(data => {
      this.FieldsValues[FieldType.PurchaseDate] = new Date(data.content);
      this.saveButt = true;
      }
    );
  }

  editField(field: FieldType, dialCOntent: string) { // zamienic to na enuma fieldType
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    const titleData = this.FieldsTitles[field];
    dialogConfig.data = {
        fieldType: field,
        fieldName: titleData,
        content: dialCOntent
    };
    const renameDialogRef = this.dialog.open(RenameDialogComponent, dialogConfig).afterClosed().subscribe(data => {
      if (data !== undefined) {
        this.saveButt = true;
        if (data.fieldType === FieldType.LinkedFileds) {
          if (data.content.length > 0) {
            const subscribver = this.dbService.getTagExistResult().subscribe(result => {
              if (result) {
                if (!this.FieldsValues[data.fieldType].includes(data.content)) {
                  this.FieldsValues[data.fieldType].push(data.content);
                  this.messageLinkedField = '';
                } else {
                  this.messageLinkedField = $localize`:@@itemdetails.tagOnList:Ten znacznik już znajduje się na liście`;
                }
              } else {
                this.messageLinkedField = $localize`:@@itemdetails.tagDoesnNotExist:Nie istnieje taki znacznik`;
              }
              subscribver.unsubscribe();
            });
            this.dbService.checkTagExisting(data.content);
          }
        } else {
          this.FieldsValues[data.fieldType]  = data.content;
        }
      }
    });
  }

  editLocation(field: FieldType, dialCOntent: string) { // zamienic to na enuma fieldType
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    const titleData = this.FieldsTitles[field];
    const locations = new Array<string>();
    this.dbService.locations.forEach(loc => {
      locations.push(loc.NAME);
    });

    dialogConfig.data = {
        fieldType: field,
        fieldName: titleData,
        content: locations
    };
    const renameDialogRef = this.dialog.open(ComboDialogComponent, dialogConfig).afterClosed().subscribe(data => {
      if (data !== undefined) {
        this.saveButt = true;
        this.FieldsValues[data.fieldType]  = data.content;
      }
    });
  }

  isQrTag(UID: string): boolean {
    return UID.startsWith('QR');
  }

  isBarTag(UID: string): boolean {
    if (this.dbService.tagItems.get(this.FieldsValues[FieldType.RFIDNumber]).TYPE !== undefined) {
      return (!this.dbService.tagItems.get(this.FieldsValues[FieldType.RFIDNumber]).TYPE.includes('QR'));
    }
    return false;
  }


  shorQRCode(uid: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'imgclass'  ;
    dialogConfig.autoFocus = true;
    console.log(this.dbService.tagItems.get(this.FieldsValues[FieldType.RFIDNumber]).TYPE);
    dialogConfig.data = {
        UID: uid,
        TYPE: this.dbService.tagItems.get(this.FieldsValues[FieldType.RFIDNumber]).TYPE
    };
    this.dialog.open(ImgDialogComponent, dialogConfig) ;
  }

}
